/**
 * Created by WebStorm.
 * User: liulin
 * Date: 2018/9/27
 * Time: 下午1:47
 */

import { Http } from '../common'

export function getToken (url, username) {
  return Http.post(`${url}/Token/getToken`, {username})
}



// WEBPACK FOOTER //
// ./src/apis/im.js